module.exports = __webpack_public_path__ + "img/favicon.bd93b74.png";